import { render } from "./transscriptComponent.vue?vue&type=template&id=39ad4c62&scoped=true"
import script from "./transscriptComponent.vue?vue&type=script&lang=js"
export * from "./transscriptComponent.vue?vue&type=script&lang=js"

import "./transscriptComponent.vue?vue&type=style&index=0&id=39ad4c62&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ad4c62"]])

export default __exports__